var map = {
	"./": 90,
	"./LICENSE": 243,
	"./README.md": 244,
	"./android": 155,
	"./android.js": 155,
	"./darwin": 165,
	"./darwin.js": 165,
	"./freebsd": 166,
	"./freebsd.js": 166,
	"./ibmi": 167,
	"./ibmi.js": 167,
	"./index": 90,
	"./index.js": 90,
	"./linux": 168,
	"./linux.js": 168,
	"./openbsd": 169,
	"./openbsd.js": 169,
	"./package": 170,
	"./package.json": 170,
	"./sunos": 171,
	"./sunos.js": 171,
	"./win32": 172,
	"./win32.js": 172
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 242;